import { render, staticRenderFns } from "./UiSelect.vue?vue&type=template&id=310f3ca5"
import script from "./UiSelect.vue?vue&type=script&lang=js"
export * from "./UiSelect.vue?vue&type=script&lang=js"
import style0 from "./UiSelect.vue?vue&type=style&index=0&id=310f3ca5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports